import Param from '../../param';

const param = new Param();

/* ---------------------------------------

    -- 要素の表示、非表示を管理

--------------------------------------- */
export default class Contents{
    constructor(){
        this.$scrollDown =  $("#l-scrolldown");
        this.$pageTop =  $("#l-pagetop");

        this.$headNavi =  $("#l-header-navi>ul");
        this.$headBtn =  $("#l-header-btn");

        this.$share =  $("#c-share");

        this.$footer = $("#l-footer");

        if($("#top")[0]){
            this.$lastSection = $("#p-csr");
            this.offset = {
                pagetop : this.$lastSection.offset().left,
                scrollDown : this.$lastSection.offset().left,
            }
        }else{
            this.$lastSection = $(".p-lowlayer-section").last();
            this.offset = {
                pagetop : this.$lastSection.offset().top,
                scrollDown : this.$lastSection.offset().top,
            }
        }

        this.status = {
            pagetop    : true,
            scrollDown : true,
        }

        this.w = 0;
        this.h = 0;
        this.device="";

        TweenMax.set(this.$pageTop,{
            x:Useragnt.mobile?-300:300
        });

    }
    init(){
        this.$scrollDown =  $("#l-scrolldown");
        this.$pageTop =  $("#l-pagetop");

        this.$headNavi =  $("#l-header-navi>ul");
        this.$headBtn =  $("#l-header-btn");

        this.$share =  $("#c-share");

        this.$footer = $("#l-footer");

        if($("#top")[0]){
            this.$lastSection = $("#p-csr");
            this.offset = {
                pagetop : this.$lastSection.offset().left,
                scrollDown : this.$lastSection.offset().left,
            }
        }else{
            this.$lastSection = $(".p-lowlayer-section").last();
            this.offset = {
                pagetop : this.$lastSection.offset().top,
                scrollDown : this.$lastSection.offset().top,
            }
        }

        this.status = {
            pagetop    : true,
            scrollDown : true,
        }

        this.w = 0;
        this.h = 0;
        this.device="";

        TweenMax.set(this.$pageTop,{
            x:Useragnt.mobile?-300:300
        });

    }
    update(inc){

        /* ---------------------------------------------

         -- [ ページトップの表示 ]

        --------------------------------------------- */
        if( this.offset.pagetop <= inc ){

            if(!this.status.pagetop){
                this.status.pagetop = true;
                this.$pageTop.addClass("is-active")
                TweenMax.to(this.$pageTop,0.48,{
                    x:0
                });
                TweenMax.to(this.$scrollDown,0.48,{
                    x:Useragnt.mobile?-300:300
                });
            }
        }else{
            if(this.status.pagetop){
                this.status.pagetop = false;
                this.$pageTop.removeClass("is-active")
                TweenMax.to(this.$pageTop,0.48,{
                    x:Useragnt.mobile?-300:300
                });
            }
        }
        /* ---------------------------------------------

         -- [ スクロールダウンの表示 ]

        --------------------------------------------- */

        if( this.offset.scrollDown <= inc ){

            if(this.status.scrollDown){
                this.status.scrollDown = false;
                this.$scrollDown.removeClass("is-active")
                TweenMax.to(this.$scrollDown,0.48,{
                    x:Useragnt.mobile?-300:300
                });
            }
        }else{
            if(!this.status.scrollDown){
                this.status.scrollDown = true;
                this.$scrollDown.addClass("is-active")
                TweenMax.to(this.$scrollDown,0.48,{
                    x:0
                });
            }
        }

        /* ---------------------------------------------

         -- [ シェアボタンの表示 ]

        --------------------------------------------- */

        if( this.h/2 <= inc ){

            this.$share.addClass('is-color');

        }else{

            this.$share.removeClass('is-color');

        }

        // /* ---------------------------------------------
        //
        //  -- [ グローバルナビのボタンの表示 ]
        //
        // --------------------------------------------- */
        //
        // if( this.h < inc){
        //     if(param.displayType!=="pc") return;
        //     TweenMax.to(this.$headNavi,0.48,{
        //         y:-100
        //     });
        //     TweenMax.to(this.$headBtn,0.48,{
        //         y:0
        //     });
        // }else{
        //     if(param.displayType!=="pc") return;
        //     TweenMax.to(this.$headNavi,0.48,{
        //         y:0
        //     });
        //     TweenMax.to(this.$headBtn,0.48,{
        //         y:-100
        //     });
        // }

    }
    resize (winW,winH,device) {
        this.w = winW;
        this.h = winH;
        this.device = device;

        if(this.device==="pc"){
            this.offset.pagetop = this.$lastSection.offset().left*0.9;
            this.offset.scrollDown = this.$lastSection.offset().left*0.9;
        }else{
            this.offset.pagetop = this.$lastSection.offset().top+this.$lastSection.innerHeight()-this.h-100;
            this.offset.scrollDown = 10;
        }
        // this.offset.campaign = this.$campaignContainer[0] ? this.$campaignContainer.offset().top : '';
        // this.offset.gif0 = this.$gifContainer0[0] ? this.$gifContainer0.offset().top : '';
        // this.offset.gif1 = this.$gifContainer1[0] ? this.$gifContainer1.offset().top : '';
        // this.offset.gif1Height  = this.$gifContainer1[0] ? this.$gifContainer1.innerHeight(): '';
        //
        // for(let i=0; i<this.status.cssAniLEN; i++){
        //     this.offset.cssAni[i] = this.$cssAni.eq(i).offset().top;
        // }


    }
}
